export enum SignInProvider {
  Google = 'google',
  Facebook = 'facebook',
  Email = 'email',
  Apple = 'apple',
  MagicLink = 'magic_link'
}
